import React from 'react';
import { View, ViewProps } from 'react-native';
import useStyles from './Card.styles';

export type CardProps = ViewProps & {
  variant?: 'simple' | 'elevated' | 'outlined';
};

export const Card: React.FC<CardProps> = ({ children, variant = 'simple', style, ...props }) => {
  const s = useStyles({ variant });

  return (
    <View style={[s.root, style]} {...props}>
      {children}
    </View>
  );
};
